const state = {
	// 程序界面头宽高
	headerWidth: 0,
	headerHeight: 0,
	
	// 菜单栏宽高
	sidebarWidth: 0,
	sidebarHeight: 0,
	
	summaryreportdata:[],
	puchasepayreportdata:[],
	deptreportdata:[],
	deptreportdata1:[],
	
	recordCount: 50,
	language: 'zh_cn',
	loadingOption: {
		lock: true,
		text: 'Loading...Please wait...',
		spinner: 'el-icon-loading',
		background: 'rgba(0, 0, 0, 0.7)'
	},
}

// 以计算属性形式返回
const getters = {

}

// 异步获取值后commit mutations更改值
const actions = {

}

// 更改值
const mutations = {
	setData(state, dataObj) {

		for (let prop in dataObj) {
			if (dataObj[prop] !== undefined) {
				state[prop] = dataObj[prop];
				// console.log(state[prop]);
			}
		}
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/system.js